import React, { Component } from 'react'
import moment from 'moment'


export default class History extends Component {
    constructor(props){
        super(props)
        this.state = {
            historyShow: ""
        }
    }

    componentDidMount() {
        this.makeHistoryList()
    }

    componentDidUpdate(prevProps){
        if(prevProps.date !== this.props.date){
            this.makeHistoryList()
        }
    }

    makeHistoryList = () => {
        let history = this.props.history
        console.log("8899 history")
        let historyShow = history.map(obj => {
            return (
                <React.Fragment>
                    <div className="row mt-3 border">
                        <div className="col-md-12 my-2">
                            <label><strong>Data de submissão</strong></label>
                            <p>{moment(obj['submissionDate']).format('DD/MM/YY')}</p>
                        </div>
                        <div className="col-md-12 my-2">
                            <label><strong>Responsável do pedido</strong></label>
                            <p>{obj['orderResponsible']}</p>
                        </div>
                        <div className="col-md-12 my-2">
                            <label><strong>Estado da decisão</strong></label>
                            <p>{obj['decisionStatus']}</p>
                        </div>
                    </div>
                </React.Fragment>
            )
        })
        if(historyShow.length == 0) {
            historyShow = <React.Fragment>
                <div className="row mt-3 border">
                    <div className="col-md-12 my-2 text-center">
                        <label><strong>Sem dados a apresentar</strong></label>
                    </div>
                </div>
            </React.Fragment>
        }
        this.setState({
            historyShow
        })
        
    }

    render() {
        return (
            <React.Fragment>
                <div className="tab-content mx-4 mt-3">
                    {
                        this.state.historyShow
                    }
                    
                </div>
            </React.Fragment>
        )
    }
}
